
<template>
  <span>
    <a v-for="(txt, idx) in breadcrumb" :key="txt+idx" @click="handleClick(txt, idx)">
      {{ txt }}
      <v-icon v-if="idx < (breadcrumb.length-1)">mdi-chevron-right</v-icon>
    </a>
  </span>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'BaseBreadcrumb',
  props: {
    url: {
      type: String,
    },
    split_item: {
      type: String,
      default: '/'
    }
  },
  //mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      
    }
  },
  methods: {
    handleClick(txt, idx) {
      console.log({txt, idx});
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    data(){
      return this.url || this.$route.fullPath
    },
    breadcrumb(){
      let arr = this.data.split(this.split_item)
      let txt = arr.filter(a=> !!a).map(a=> this.$t(`${a}.${a}`))
      // console.log({arr, txt});
      return txt
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>